"use client";

import { cn } from "@devhop/ui";
import { MapPin } from "lucide-react";
import { setStoredMerchantPosBranchId } from "@/modules/merchant/presentation/lib/merchant-pos-branch-storage";

export type ShopPosBranchOption = {
  id: string;
  label: string;
};

export type ShopPosBranchPickerProps = {
  options: ShopPosBranchOption[];
  value: string | null;
  onChange: (branchId: string) => void;
  shopId?: string;
  className?: string;
};

/** ເລືອກສາຂາ POS — pill ແຕະເລືອກ (ແທນ dropdown) */
export function ShopPosBranchPicker({
  options,
  value,
  onChange,
  shopId,
  className,
}: ShopPosBranchPickerProps) {
  if (options.length <= 1 || value == null) return null;

  return (
    <div className={cn("mt-3", className)}>
      <p
        id="pos-branch-picker-label"
        className="mb-2 font-medium text-[10px] text-muted-foreground uppercase tracking-wider"
      >
        ສາຂາ POS
      </p>
      <div
        role="radiogroup"
        aria-labelledby="pos-branch-picker-label"
        className="-mx-1 flex gap-2 overflow-x-auto px-1 pb-0.5 [scrollbar-width:thin]"
      >
        {options.map((o) => {
          const selected = o.id === value;
          const inactive = o.label.endsWith(" · ປິດ");
          return (
            <button
              key={o.id}
              type="button"
              role="radio"
              aria-checked={selected}
              title={o.label}
              onClick={() => {
                if (selected) return;
                onChange(o.id);
                if (shopId) setStoredMerchantPosBranchId(shopId, o.id);
              }}
              className={cn(
                "inline-flex max-w-[min(100%,14rem)] shrink-0 items-center gap-1.5 rounded-full border px-4 py-2 font-medium text-sm transition-colors",
                "min-h-10 touch-manipulation",
                selected
                  ? "border-primary bg-primary text-primary-foreground shadow-sm"
                  : "border-border bg-background text-foreground hover:border-primary/40 hover:bg-muted/60",
                inactive && !selected && "opacity-75",
              )}
            >
              <MapPin
                className={cn(
                  "size-3.5 shrink-0",
                  selected ? "text-primary-foreground" : "text-primary",
                )}
                aria-hidden
              />
              <span className="truncate">{o.label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
